import React, { useRef } from "react";
import { Close } from "@mui/icons-material";
import headerImage from "~/images/modal-background-image.png";
import useOutsideClick from "../../../Hooks/useOutsideClick";

const DeleteMappingModal = ({ mappingName, deleting, onConfirm, onCancel }) => {
  const modalRef = useRef();
  useOutsideClick(modalRef, onCancel);

  return (
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={headerImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={onCancel}>
            <Close />
          </div>
        </div>
        <div className="tpa-modal__body">
          <div className="t--xl t--500">Delete Mapping?</div>
          <div className="t--subtitle">
            This will permanently delete <strong>{mappingName}</strong> and all of its column
            assignments. This action cannot be undone.
          </div>
          <div className="flex justify-content-end gap--16">
            <button
              className="button button--lg button--white"
              onClick={onCancel}
              disabled={deleting}
            >
              Cancel
            </button>
            <button
              className="button button--blue button--lg"
              onClick={onConfirm}
              disabled={deleting}
            >
              {deleting ? <div className="loading-indicator" /> : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteMappingModal;
